'use client'

import type { ReactNode } from 'react'
import { ASSETS_BASE_URL } from '@/constants'

import InfoItem from './InfoItem'

export type RatesChargesItem = {
  header?: string
  subheader?: string
  className?: string
}

type RatesChargesProps = {
  /** Inner node of the `.pf-rates` heading. Defaults to "Our rates & charges". */
  heading?: ReactNode
  image?: string
  imageAlt?: string
  items: RatesChargesItem[]
  /** Wrapper class around the items. `row` for the standard 2-column grid, `col` for stacked. */
  itemsClassName?: string
}

/**
 * "Our rates & charges" section shared across the personal-financing microsite pages.
 * Previously copy-pasted into every PF page view.
 */
const DEFAULT_IMAGE = `${ASSETS_BASE_URL}assets/files/pf_alia_8c3352640b.webp`
const RatesCharges = ({
  heading,
  image,
  imageAlt = 'Rates and charges',
  items,
  itemsClassName = 'row'
}: RatesChargesProps) => {
  return (
    <section className="section about container">
      <div className="row align-items-center" data-aos="fade-up" data-aos-delay="200">
        <div className="col-md-4 order-lg-1 order-2 img-fluid-pf">
          <img src={image ?? DEFAULT_IMAGE} alt={imageAlt} className="img-fluid-pf" />
        </div>
        <div className="col-md-8 order-lg-2 order-1" data-aos="zoom-in" data-aos-delay="200">
          <div className="pf-rates pb-4">{heading ?? <span>Our rates &amp; charges</span>}</div>
          <div className={itemsClassName}>
            {items.map((item, index) => (
              <InfoItem key={index} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default RatesCharges
